import { render, staticRenderFns } from "./vue-dialog-drag.vue?vue&type=template&id=69afa1d3&lang=pug"
import script from "./vue-dialog-drag.vue?vue&type=script&lang=js"
export * from "./vue-dialog-drag.vue?vue&type=script&lang=js"
import style0 from "./vue-dialog-drag.vue?vue&type=style&index=0&id=69afa1d3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports